// extracted by mini-css-extract-plugin
module.exports = {"reportPopup":"reportPopup-module__reportPopup___YQS8+","popup":"reportPopup-module__popup___LQSAc"};